/**
 * @file Pipe used for translating entity names or retrieving labels involving an entity
 * @author Maarten Lensink
 */
import { PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
/**
 * The class for entity translation functionality
 */
var EntityTranslatePipe = /** @class */ (function () {
    function EntityTranslatePipe(translateService) {
        this.translateService = translateService;
    }
    EntityTranslatePipe.prototype.transform = function (entityName, label, domain) {
        if (domain === void 0) { domain = 'MISC'; }
        var key = 'APP.' + domain + '.' + entityName.toUpperCase() + '.';
        if (!label) {
            label = 'SINGULAR';
        }
        label = label.toUpperCase();
        if (label === 'SINGULAR' || label === 'PLURAL' || label === 'NEW' || label === 'OVERVIEW') {
            key += '#';
        }
        key += label;
        return this.translateService.instant(key);
    };
    return EntityTranslatePipe;
}());
export { EntityTranslatePipe };
